import { render, staticRenderFns } from "./PricesControl.vue?vue&type=template&id=242ea0a9&"
import script from "./PricesControl.vue?vue&type=script&lang=js&"
export * from "./PricesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports